export default function padZero(num) {
  return num < 10 ? '0' + num : num;
}
